module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av680-19adc3c65f89f8313d90015d9332d0e4.jpg";